<template>
	<modal ref="modal" size="modal-xl">
		<template #title>STOCK DETAILS</template>
		<template v-if="stockDetails!=null" #body>
			<div class="block block-rounded overflow-hidden">
				<div class="block-content block-content-full border-bottom d-flex justify-content-between align-items-center">
		          	<h2 class="mb-0">{{stockDetails.company_title}}</h2>
	            </div>
				<div class="block-content block-content-full">
					<div class="row py-3">
						<div class="col-sm-5">
							<img :src="stockDetails.company_logo_url" alt="" style="width:100%">
							<!-- Company Info -->
	                  		<table class="table table-striped table-borderless mt-3">
			                    <tbody>
			                      <tr>
			                        <td class="fw-semibold">Sector</td>
			                        <td>{{stockDetails.sector}}</td>
			                      </tr>
			                      <tr>
			                        <td class="fw-semibold">Subsector</td>
			                        <td>{{stockDetails.sub_sector}}</td>
			                      </tr>
			                      <tr>
			                        <td class="fw-semibold">Incorporation Date</td>
			                        <td>{{stockDetails.listing_date}}</td>
			                      </tr>
			                      <tr>
			                        <td class="fw-semibold">Website</td>
			                        <td>
			                          <a :href="'https://'+stockDetails.website" target="_blank">{{stockDetails.website}}</a>
			                        </td>
			                      </tr>
			                      <tr>
			                        <td class="fw-semibold">Last Traded Price</td>
			                        <td>
			                          PHP {{stockDetails.tradeprice}}
			                        </td>
			                      </tr>
			                      <tr>
			                        <td class="fw-semibold">Included in SAM?</td>
			                        <td>
			                          {{stockDetails.sam_include}}
			                        </td>
			                      </tr>
			                    </tbody>
		                  	</table>
		                  	<!-- END Company Info -->
						</div>
						<div class="col-sm-7">
							<h3 class="mb-2">Company Description</h3>
							<div style="white-space: pre; white-space:break-spaces;" v-html="stockDetails.description"></div>
						</div>
					</div>
					<div class="row py-3">
						<p v-if="(stockDetails.stock_comments!=null && stockDetails.stock_comments.length>0) || (stockDetails.stock_history!=null && stockDetails.stock_history.length>0)" class="p-0 fw-bold pb-1 mb-1 border-bottom border-info">UPDATES</p>
						<table v-if="stockDetails.stock_history!=null && stockDetails.stock_history.length>0" class="table">
							<thead>
								<tr>
									<th>Prev Trade Date</th>
									<th>Trade Price</th>
									<th>Buy Below Price</th>
									<th>Target Price</th>
									<th>Max %</th>
									<th>Dividend Yield 25E %</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(stock_history,index) in stockDetails.stock_history">
									<td>{{stock_history.lasttradedate}}</td>
									<td>{{stock_history.tradeprice}}</td>
									<td>{{stock_history.buybelowprice}}</td>
									<td>{{stock_history.targetprice}}</td>
									<td>{{stock_history.maxperc}}</td>
									<td>{{stock_history.dividend_yield_25e}}</td>
								</tr>
							</tbody>
						</table>
						<div v-if="stockDetails.stock_comments!=null && stockDetails.stock_comments.length>0" class="p-0 m-0">
							<div v-for="(stock_comments,index) in stockDetails.stock_comments" class="block mb-0 border-bottom" :class="{'border-top':index>0}">
								<div class="block-content block-content-full px-0">
									<div class="fs-xs text-muted fst-italic">Posted at: {{stock_comments.created_at_format}}</div>
					                <div class="fs-sm mt-4" style="white-space: pre; white-space:break-spaces;" v-html="stock_comments.description">
						                
						            </div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-if="stockDetails!=null" #footer>
			<button @click="toggleModal" type="button" class="btn btn-alt-secondary">
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { watch, ref } from 'vue'
import { Inertia } from '@inertiajs/inertia'

export default {
	props:{
		stockDetails: Object
	},
	setup(props) {

		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal();
		}

		// watch(()=>props.stock,(value)=>{
		// 	if(value!=null)
		// 	{
				
		// 		Inertia.get(
		// 			'/member/recommendations/details/'+props.stock,{},
		// 			{
		// 				// replace: true,
		// 				preserveState: true,
		// 				preserveScroll: true,
		// 				only:['stockDetails']
		// 			}
		// 		)

		// 	}
		// })


		return{
			modal,
			toggleModal
		}
	}
}
</script>